<template>
  <div>
    <div class="job-section">
      <h2>📌 招聘職位</h2>
      <p><strong>共享充電寶行街 Sales</strong></p>
      <p>💰 <strong>薪資範圍</strong>：HK$25,000 – HK$35,000 / 月</p>

      <h3>工作職責</h3>
      <ul>
        <li>尋找新的潛在合作商戶並洽談合作，達成業務拓展目標</li>
        <li>
          針對 ChrgiePower 共享充電寶
          展開線下優質商戶拓展與鋪設（如酒店、商場、網紅餐飲、美容、KTV
          會所、酒吧、景區、醫院、交通樞紐、展館、大型連鎖等人口密集場所）
        </li>
        <li>負責跟進及簽約商戶，設備到店後進行調試、安裝及商戶端培訓</li>
        <li>設備安裝後的日常維護、客戶關係跟進、二次開發及深度合作</li>
        <li>收集商戶及用戶使用反饋，協助解決使用過程中的問題</li>
        <li>與公司各部門協作，處理市場信息反饋，提升運營效率與用戶滿意度</li>
      </ul>

      <h3>職位要求</h3>
      <ul>
        <li>DSE 或文憑以上，專業不限</li>
        <li>具備優秀學習能力、積極主動、不怕挑戰</li>
        <li>有商務拓展或銷售經驗者優先，對本地市場有一定認知</li>
        <li>能以廣東話、英語及普通話進行溝通</li>
        <li>性格開朗外向，具備抗壓能力與業務談判能力</li>
      </ul>

      <h3>公司福利</h3>
      <ul>
        <li>5 天工作日</li>
        <li>公眾假期</li>
        <li>有競爭力的底薪 + 高額提成</li>
        <li>薪資調整機會</li>
        <li>10 天年假</li>
        <li>在職培訓</li>
        <li>良好工作環境</li>
        <li>職業晉升發展空間</li>
      </ul>

      <h3>📧 申請方式</h3>
      <p>
        請將個人履歷表及期望薪酬發送至：<br />
        <strong>elevennewstartpoint@chrgiepower.com</strong>
      </p>
    </div>
    <viewFooter></viewFooter>
  </div>
</template>
<script>
import viewFooter from '@/views/view-footer.vue'
export default {
  name: "AdvertisingPlatform",
  components: {
    viewFooter
   },
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.job-section {
  background-color: rgb(236, 105, 61); /* 和菜单一样 */
  color: #fff; /* 白色字 */
  padding: 30px 50px;
  line-height: 1.8;
}

.job-section h2 {
  font-size: 28px;
  margin-bottom: 10px;
}

.job-section h3 {
  font-size: 22px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.job-section p {
  margin: 5px 0;
}

.job-section ul {
  padding-left: 20px;
}

.job-section li {
  margin-bottom: 6px;
}
</style>
